import { Auth } from './services/Auth'
import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

declare module '#app' {
  interface NuxtApp {
    $auth: Auth
  }
}

declare module 'vue' {
  interface NuxtApp {
    $auth: Auth
  }
}

export default defineNuxtPlugin(() => {
  const {
    public: { auth },
  } = useRuntimeConfig()

  // @ts-expect-error runtime-only
  const authService = new Auth($fetch)
  if (auth.useGlobalFetch)
    globalThis.$fetch = authService.$fetch

  return {
    provide: {
      auth: authService,
    },
  }
})
